﻿
<div class="dsk-wrap" *ngIf="loading">
  <div class="dsk-tabs">
    <div class="dsk-tab dsk-pulse" *ngFor="let t of [1,2,3]"></div>
  </div>
  <div class="dsk-split dsk-split-1-2" style="align-items:flex-start">
    <div class="dsk-panel">
      <div class="dsk-panel-head">
        <div class="dsk-search dsk-pulse" style="flex:1"></div>
      </div>
      <div style="display:flex;gap:6px;padding:10px 14px;flex-wrap:wrap">
        <div class="dsk-chip dsk-pulse" style="width:56px;height:26px" *ngFor="let p of [1,2,3,4]"></div>
      </div>
      <div class="dsk-panel-body" style="gap:8px;padding:8px 12px">
        <div *ngFor="let e of [1,2,3,4,5,6,7,8]" style="display:flex;align-items:center;gap:10px;padding:10px 12px;background:#faf8ff;border-radius:9px;border:1px solid #ece9e6">
          <div class="dsk-avatar dsk-pulse" style="border-radius:50%"></div>
          <div style="flex:1;display:flex;flex-direction:column;gap:5px">
            <div class="dsk-cell dsk-pulse" style="width:120px;height:13px"></div>
            <div class="dsk-cell dsk-pulse" style="width:80px;height:11px"></div>
          </div>
          <div class="dsk-badge dsk-pulse" style="width:56px;border-radius:20px"></div>
        </div>
      </div>
    </div>
    <div class="dsk-panel">
      <div class="dsk-hero-banner dsk-pulse" style="height:80px"></div>
      <div style="padding:0 20px 20px;margin-top:-24px">
        <div class="dsk-hero-av dsk-pulse" style="width:60px;height:60px;margin-bottom:12px"></div>
        <div class="dsk-cell dsk-pulse" style="width:150px;height:17px"></div>
        <div class="dsk-cell dsk-pulse" style="width:100px;height:12px;margin-top:6px"></div>
        <div style="display:flex;gap:8px;margin-top:10px">
          <div class="dsk-chip dsk-pulse" style="width:70px;height:24px" *ngFor="let c of [1,2,3]"></div>
        </div>
      </div>
      <div style="padding:0 20px 20px;display:flex;flex-direction:column;gap:12px">
        <div *ngFor="let f of [1,2,3,4]" style="display:flex;justify-content:space-between;padding:10px 0;border-bottom:1px solid #f0eeec">
          <div class="dsk-cell dsk-pulse" style="width:90px;height:12px"></div>
          <div class="dsk-cell dsk-pulse" style="width:130px;height:12px"></div>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="ph-page" *ngIf="!loading">

  <div class="ph-page-tabs">
    <button class="ph-page-tab" [class.active]="pageTab==='people'" (click)="switchPageTab('people')">
      <svg viewBox="0 0 16 16" fill="none" width="13" height="13"><circle cx="8" cy="5" r="3" stroke="currentColor" stroke-width="1.4"/><path d="M2 14c0-3.314 2.686-6 6-6s6 2.686 6 6" stroke="currentColor" stroke-width="1.4" stroke-linecap="round"/></svg>
      People
    </button>
    <button class="ph-page-tab" [class.active]="pageTab==='attendance'" (click)="switchPageTab('attendance')">
      <svg viewBox="0 0 16 16" fill="none" width="13" height="13"><rect x="1" y="3" width="14" height="11" rx="2" stroke="currentColor" stroke-width="1.4"/><path d="M5 1v3M11 1v3M1 7h14" stroke="currentColor" stroke-width="1.4" stroke-linecap="round"/></svg>
      Attendance
    </button>
    <button class="ph-page-tab" [class.active]="pageTab==='leaves'" (click)="switchPageTab('leaves')">
      <svg viewBox="0 0 16 16" fill="none" width="13" height="13"><path d="M8 2C5 5 2 7.5 2 10a6 6 0 0 0 12 0c0-2.5-3-5-6-8z" stroke="currentColor" stroke-width="1.4" stroke-linejoin="round"/></svg>
      Leave Approvals
      <span class="ph-page-tab-badge" *ngIf="pendingLeavesCount > 0">{{ pendingLeavesCount }}</span>
    </button>
  </div>

  <div class="ph-list-col" *ngIf="pageTab==='people'">

    <div class="ph-list-header">
      <div class="ph-list-title-row">
        <span class="ph-list-title">People</span>
        <span class="ph-count-chip">{{ filteredEmployees.length }}</span>
      </div>
      <button class="ph-add-btn" (click)="showAddEmp=true" *ngIf="canEdit()">
        <svg viewBox="0 0 16 16" fill="none" width="13" height="13">
          <path d="M8 3v10M3 8h10" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
        </svg>
        New
      </button>
    </div>

    <div class="ph-search-wrap">
      <svg viewBox="0 0 18 18" fill="none" width="14" height="14" class="ph-search-ico">
        <circle cx="7.5" cy="7.5" r="5" stroke="currentColor" stroke-width="1.6"/>
        <path d="M11.5 11.5l3.5 3.5" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/>
      </svg>
      <input type="text" class="ph-search-input" [(ngModel)]="searchText" placeholder="Search by name, ID or email...">
      <button class="ph-search-clear" *ngIf="searchText" (click)="searchText=''">
        <svg viewBox="0 0 14 14" fill="none" width="11" height="11">
          <path d="M3 3l8 8M11 3l-8 8" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
        </svg>
      </button>
    </div>

    <div class="ph-filter-row">
      <button class="ph-fpill" [class.ph-fpill--active]="filterStatus==='all'"      (click)="filterStatus='all'">All</button>
      <button class="ph-fpill" [class.ph-fpill--active]="filterStatus==='active'"   (click)="filterStatus='active'">Active</button>
      <button class="ph-fpill" [class.ph-fpill--active]="filterStatus==='inactive'" (click)="filterStatus='inactive'">Inactive</button>
      <button class="ph-fpill" [class.ph-fpill--active]="filterStatus==='on_leave'" (click)="filterStatus='on_leave'">On Leave</button>
    </div>

    <div class="ph-emp-list">
      <div class="ph-emp-card"
           *ngFor="let emp of filteredEmployees"
           [class.ph-emp-card--active]="selectedEmp?.id === emp.id"
           (click)="selectEmployee(emp)">
        <div class="ph-emp-av" [style.background]="getAvatarGradient(emp.firstName + ' ' + emp.lastName)">
          {{ getInitials(emp) }}
        </div>
        <div class="ph-emp-info">
          <div class="ph-emp-name">{{ emp.firstName }} {{ emp.lastName }}</div>
          <div class="ph-emp-sub">{{ emp.position || emp.role || 'Employee' }}</div>
        </div>
        <div class="ph-emp-status-dot" [ngClass]="getStatusClass(emp.status)"></div>
      </div>

      <div class="ph-list-empty" *ngIf="filteredEmployees.length === 0">
        <svg viewBox="0 0 40 40" fill="none" width="36" height="36">
          <circle cx="20" cy="14" r="7" stroke="currentColor" stroke-width="1.5"/>
          <path d="M6 36c0-7.732 6.268-14 14-14s14 6.268 14 14" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
        </svg>
        <p>No people found</p>
      </div>
    </div>
  </div>

  <div class="ph-detail-col" *ngIf="pageTab==='people'">

    <div class="ph-no-selection" *ngIf="!selectedEmp && !loading">
      <svg viewBox="0 0 64 64" fill="none" width="56" height="56">
        <circle cx="32" cy="22" r="12" stroke="currentColor" stroke-width="1.5" opacity=".5"/>
        <path d="M8 56c0-13.255 10.745-24 24-24s24 10.745 24 24" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" opacity=".5"/>
      </svg>
      <p class="ph-no-sel-text">Select an employee to manage</p>
    </div>

    <div class="ph-detail-loading" *ngIf="detailLoading">
      <svg class="ph-spin" viewBox="0 0 24 24" fill="none" width="28" height="28">
        <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-dasharray="40 20"/>
      </svg>
    </div>

    <div class="ph-detail" *ngIf="selectedEmp && !detailLoading">

      <div class="ph-hero">
        <div class="ph-hero-top">

          <div class="ph-hero-av-wrap">
            <div class="ph-hero-av" [style.background]="getAvatarGradient(selectedEmp.firstName + ' ' + selectedEmp.lastName)">
              {{ getInitials(selectedEmp) }}
            </div>
            <span class="ph-hero-av-ring" [ngClass]="getStatusClass(selectedEmp.status)"></span>
          </div>

          <div class="ph-hero-info">
            <div class="ph-hero-name-row">
              <span class="ph-hero-name">{{ selectedEmp.firstName }} {{ selectedEmp.lastName }}</span>
              <span class="ph-status-badge" [ngClass]="getStatusClass(selectedEmp.status)">
                <span class="ph-status-dot"></span>
                {{ selectedEmp.status === 'on_leave' ? 'On Leave' : (selectedEmp.status | titlecase) }}
              </span>
            </div>

            <div class="ph-hero-role-row">
              <span class="ph-hero-role">{{ selectedEmp.position || (selectedEmp.role | titlecase) }}</span>
              <span class="ph-role-sep"></span>
              <span class="ph-hero-dept">{{ getDeptName(selectedEmp.departmentId) }}</span>
              <span class="ph-emp-id-tag">{{ selectedEmp.employeeId || 'No ID' }}</span>
            </div>

            <div class="ph-hero-contact">
              <span class="ph-contact-item">
                <svg viewBox="0 0 16 16" fill="none" width="11" height="11"><path d="M2 4l6 5 6-5" stroke="currentColor" stroke-width="1.3" stroke-linecap="round"/><rect x="1" y="3" width="14" height="10" rx="2" stroke="currentColor" stroke-width="1.3"/></svg>
                {{ selectedEmp.email || '—' }}
              </span>
              <span class="ph-contact-item" *ngIf="selectedEmp.phone">
                <svg viewBox="0 0 16 16" fill="none" width="11" height="11"><path d="M3 1.5h3l1.5 4-2 1a10 10 0 0 0 3.5 3.5l1-2 4 1.5v3a1.5 1.5 0 0 1-1.5 1.5C7 14.5 1.5 9 1.5 3A1.5 1.5 0 0 1 3 1.5z" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/></svg>
                {{ selectedEmp.phone }}
              </span>
            </div>
          </div>

          <div class="ph-hero-btns" *ngIf="canEdit()">
            <button class="ph-act-btn" (click)="openEditEmp()">
              <svg viewBox="0 0 16 16" fill="none" width="12" height="12"><path d="M11 2.5l2.5 2.5L4 14.5H1.5V12L11 2.5z" stroke="currentColor" stroke-width="1.4" stroke-linejoin="round"/></svg>
              Edit
            </button>
            <button class="ph-act-btn ph-act-btn--danger" (click)="deleteEmployee(selectedEmp)" *ngIf="canDelete()">
              <svg viewBox="0 0 16 16" fill="none" width="12" height="12"><path d="M2 4h12M6 4V2h4v2M7 7v5M9 7v5M3 4l1 9h8l1-9" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"/></svg>
              Remove
            </button>
          </div>
        </div>

        <div class="ph-hero-stats">
          <div class="ph-stat">
            <span class="ph-stat-val">{{ presentDaysThisMonth }}</span>
            <span class="ph-stat-lbl">Present (MTD)</span>
          </div>
          <div class="ph-stat-div"></div>
          <div class="ph-stat">
            <span class="ph-stat-val">{{ totalLeaveBalance }}</span>
            <span class="ph-stat-lbl">Leave Balance</span>
          </div>
          <div class="ph-stat-div"></div>
          <div class="ph-stat">
            <span class="ph-stat-val" [class.ph-stat-val--warn]="empPending.length > 0">{{ empPending.length }}</span>
            <span class="ph-stat-lbl">Pending Leaves</span>
          </div>
          <div class="ph-stat-div"></div>
          <div class="ph-stat">
            <span class="ph-stat-val">{{ empTeams.length }}</span>
            <span class="ph-stat-lbl">Teams</span>
          </div>
          <div class="ph-stat-div"></div>
          <div class="ph-stat">
            <span class="ph-stat-val">{{ selectedEmp.location || 'Office' }}</span>
            <span class="ph-stat-lbl">Location</span>
          </div>
        </div>
      </div>

      <div class="ph-tabs">
        <button class="ph-tab" [class.ph-tab--active]="activeDetailTab==='overview'"    (click)="activeDetailTab='overview'">
          <svg viewBox="0 0 16 16" fill="none" width="13" height="13"><circle cx="8" cy="5" r="3" stroke="currentColor" stroke-width="1.4"/><path d="M2 14c0-3.314 2.686-6 6-6s6 2.686 6 6" stroke="currentColor" stroke-width="1.4" stroke-linecap="round"/></svg>
          Overview
        </button>
        <button class="ph-tab" [class.ph-tab--active]="activeDetailTab==='attendance'"  (click)="activeDetailTab='attendance'">
          <svg viewBox="0 0 16 16" fill="none" width="13" height="13"><rect x="1" y="3" width="14" height="11" rx="2" stroke="currentColor" stroke-width="1.4"/><path d="M5 1v3M11 1v3M1 7h14" stroke="currentColor" stroke-width="1.4" stroke-linecap="round"/></svg>
          Attendance
          <span class="ph-tab-badge" *ngIf="presentDaysThisMonth > 0">{{ presentDaysThisMonth }}</span>
        </button>
        <button class="ph-tab" [class.ph-tab--active]="activeDetailTab==='leaves'"      (click)="activeDetailTab='leaves'">
          <svg viewBox="0 0 16 16" fill="none" width="13" height="13"><path d="M8 2C5 5 2 7.5 2 10a6 6 0 0 0 12 0c0-2.5-3-5-6-8z" stroke="currentColor" stroke-width="1.4" stroke-linejoin="round"/></svg>
          Leaves
          <span class="ph-tab-badge ph-tab-badge--warn" *ngIf="empPending.length > 0">{{ empPending.length }}</span>
        </button>
        <button class="ph-tab" [class.ph-tab--active]="activeDetailTab==='assets'"      (click)="activeDetailTab='assets'">
          <svg viewBox="0 0 16 16" fill="none" width="13" height="13"><rect x="1" y="4" width="14" height="10" rx="2" stroke="currentColor" stroke-width="1.4"/><path d="M5 4V3a3 3 0 0 1 6 0v1" stroke="currentColor" stroke-width="1.4" stroke-linecap="round"/></svg>
          Assets
          <span class="ph-tab-badge" *ngIf="empAssets.length > 0">{{ empAssets.length }}</span>
        </button>
      </div>

      <div class="ph-tab-body" *ngIf="activeDetailTab==='overview'">

        <div class="ov-card ov-card--profile">
          <div class="ov-card-head">
            <svg viewBox="0 0 16 16" fill="none" width="14" height="14"><circle cx="8" cy="5" r="3" stroke="currentColor" stroke-width="1.4"/><path d="M2 14c0-3.314 2.686-6 6-6s6 2.686 6 6" stroke="currentColor" stroke-width="1.4" stroke-linecap="round"/></svg>
            Profile Details
            <button class="ov-head-action" (click)="openEditEmp()" *ngIf="canEdit()">Edit =</button>
          </div>
          <div class="ov-fields ov-fields--2col">
            <div class="ov-field"><span class="ov-fl">Employee ID</span><span class="ov-fv ov-id">{{ selectedEmp.employeeId || '—' }}</span></div>
            <div class="ov-field"><span class="ov-fl">Email</span><span class="ov-fv">{{ selectedEmp.email || '—' }}</span></div>
            <div class="ov-field"><span class="ov-fl">Phone</span><span class="ov-fv">{{ selectedEmp.phone || '—' }}</span></div>
            <div class="ov-field"><span class="ov-fl">Department</span><span class="ov-fv">{{ getDeptName(selectedEmp.departmentId) }}</span></div>
            <div class="ov-field"><span class="ov-fl">Position</span><span class="ov-fv">{{ selectedEmp.position || '—' }}</span></div>
            <div class="ov-field"><span class="ov-fl">Role</span><span class="ov-fv">{{ selectedEmp.role | titlecase }}</span></div>
            <div class="ov-field"><span class="ov-fl">Location</span><span class="ov-fv">{{ selectedEmp.location || 'Office' }}</span></div>
            <div class="ov-field"><span class="ov-fl">Join Date</span><span class="ov-fv">{{ formatDate(selectedEmp.joiningDate || selectedEmp.createdAt) }}</span></div>
            <div class="ov-field"><span class="ov-fl">Teams</span><span class="ov-fv">{{ getTeamNames() }}</span></div>
            <div class="ov-field"><span class="ov-fl">Status</span>
              <span class="ov-fv">
                <span class="ph-status-badge" [ngClass]="getStatusClass(selectedEmp.status)">
                  <span class="ph-status-dot"></span>
                  {{ selectedEmp.status === 'on_leave' ? 'On Leave' : (selectedEmp.status | titlecase) }}
                </span>
              </span>
            </div>
          </div>
        </div>

        <div class="ov-row2">

          <div class="ov-card">
            <div class="ov-card-head">
              <svg viewBox="0 0 16 16" fill="none" width="14" height="14"><path d="M8 2C5 5 2 7.5 2 10a6 6 0 0 0 12 0c0-2.5-3-5-6-8z" stroke="currentColor" stroke-width="1.4" stroke-linejoin="round"/></svg>
              Leave Balances
              <button class="ov-head-action" (click)="showAllocate=true" *ngIf="canEdit()">+ Allocate</button>
            </div>
            <div class="ov-lb-list" *ngIf="empBalances.length > 0">
              <div class="ov-lb-row" *ngFor="let bal of empBalances">
                <div class="ov-lb-bar-wrap">
                  <div class="ov-lb-top">
                    <span class="ov-lb-type" [style.color]="getBalanceColor(bal.leaveType)">{{ bal.leaveType | titlecase }}</span>
                    <span class="ov-lb-nums"><b>{{ bal.remainingDays || bal.balance || 0 }}</b> / {{ bal.totalDays || bal.allocatedDays || 0 }} days</span>
                  </div>
                  <div class="ov-lb-bar" [style.--bar-color]="getBalanceColor(bal.leaveType)">
                    <div class="ov-lb-fill" [style.width]="((bal.remainingDays || 0) / (bal.totalDays || 1) * 100) + '%'"></div>
                  </div>
                </div>
              </div>
            </div>
            <div class="ov-empty-sub" *ngIf="empBalances.length === 0">No leave balances found</div>
          </div>

          <div class="ov-card">
            <div class="ov-card-head">
              <svg viewBox="0 0 16 16" fill="none" width="14" height="14"><rect x="1" y="3" width="14" height="11" rx="2" stroke="currentColor" stroke-width="1.4"/><path d="M5 1v3M11 1v3M1 7h14" stroke="currentColor" stroke-width="1.4" stroke-linecap="round"/></svg>
              Recent Attendance
              <button class="ov-head-action" (click)="activeDetailTab='attendance'">View All →</button>
            </div>
            <div class="ov-att-list" *ngIf="empAttendance.length > 0">
              <div class="ov-att-row" *ngFor="let rec of empAttendance.slice(0,6)">
                <span class="ov-att-date">{{ formatDate(rec.date) }}</span>
                <span class="att-badge" [ngClass]="getAttStatusClass(rec.status)">{{ rec.status }}</span>
                <span class="ov-att-time">{{ formatTime(rec.checkIn) }} –“ {{ formatTime(rec.checkOut) }}</span>
              </div>
            </div>
            <div class="ov-empty-sub" *ngIf="empAttendance.length === 0">No attendance records yet</div>
          </div>

        </div>
      </div>

      <div class="ph-tab-body" *ngIf="activeDetailTab==='attendance'">

        <div class="att-toolbar">
          <div class="att-month-wrap">
            <svg viewBox="0 0 14 14" fill="none" width="13" height="13"><rect x="1" y="2" width="12" height="11" rx="1.5" stroke="currentColor" stroke-width="1.3"/><path d="M4 1v2M10 1v2M1 6h12" stroke="currentColor" stroke-width="1.3" stroke-linecap="round"/></svg>
            <input type="month" class="att-month-inp" [(ngModel)]="attMonth" (change)="onAttMonthChange()">
          </div>
          <div class="att-filter-pills">
            <button class="att-fpill" [class.active]="attFilter==='all'"      (click)="attFilter='all'">All</button>
            <button class="att-fpill" [class.active]="attFilter==='present'"  (click)="attFilter='present'">Present</button>
            <button class="att-fpill" [class.active]="attFilter==='absent'"   (click)="attFilter='absent'">Absent</button>
            <button class="att-fpill" [class.active]="attFilter==='late'"     (click)="attFilter='late'">Late</button>
          </div>
          <button class="att-mark-btn" (click)="showMarkAtt=true" *ngIf="canEdit()">
            <svg viewBox="0 0 14 14" fill="none" width="12" height="12"><path d="M7 3v4l2.5 2.5" stroke="currentColor" stroke-width="1.4" stroke-linecap="round"/><circle cx="7" cy="7" r="6" stroke="currentColor" stroke-width="1.4"/></svg>
            Mark Attendance
          </button>
        </div>

        <div class="att-summary">
          <div class="att-sum-pill att-sum-present">
            <span class="att-sum-val">{{ attCountForStatus('present') }}</span>
            <span class="att-sum-lbl">Present</span>
          </div>
          <div class="att-sum-pill att-sum-absent">
            <span class="att-sum-val">{{ attCountForStatus('absent') }}</span>
            <span class="att-sum-lbl">Absent</span>
          </div>
          <div class="att-sum-pill att-sum-late">
            <span class="att-sum-val">{{ attCountForStatus('late') }}</span>
            <span class="att-sum-lbl">Late</span>
          </div>
          <div class="att-sum-pill att-sum-leave">
            <span class="att-sum-val">{{ attCountForStatus('on-leave') }}</span>
            <span class="att-sum-lbl">On Leave</span>
          </div>
        </div>

        <div class="att-table-wrap" *ngIf="filteredAttendance.length > 0">
          <table class="att-table">
            <thead>
              <tr>
                <th>Date</th>
                <th>Status</th>
                <th>Check In</th>
                <th>Check Out</th>
                <th>Hours</th>
                <th>Notes</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let rec of filteredAttendance">
                <td class="att-date-cell">{{ formatDate(rec.date) }}</td>
                <td><span class="att-badge" [ngClass]="getAttStatusClass(rec.status)">{{ rec.status }}</span></td>
                <td class="att-time-cell">{{ formatTime(rec.checkIn) }}</td>
                <td class="att-time-cell">{{ formatTime(rec.checkOut) }}</td>
                <td class="att-hrs-cell">
                  <span *ngIf="rec.checkIn && rec.checkOut; else noHours">{{ rec.hoursWorked || '—' }}</span>
                  <ng-template #noHours>—</ng-template>
                </td>
                <td class="att-notes-cell">{{ rec.notes || '—' }}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="tab-empty" *ngIf="filteredAttendance.length === 0">
          <svg viewBox="0 0 40 40" fill="none" width="36" height="36"><rect x="3" y="7" width="34" height="28" rx="4" stroke="currentColor" stroke-width="1.5"/><path d="M12 3v7M28 3v7M3 17h34" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg>
          <p>No attendance records for this period</p>
        </div>
      </div>

      <div class="ph-tab-body" *ngIf="activeDetailTab==='leaves'">

        <div class="lv-balances" *ngIf="empBalances.length > 0">
          <div class="lv-bal-card" *ngFor="let bal of empBalances" [style.--bal-color]="getBalanceColor(bal.leaveType)">
            <div class="lv-bal-type">{{ bal.leaveType | titlecase }}</div>
            <div class="lv-bal-nums">
              <span class="lv-bal-rem">{{ bal.remainingDays || bal.balance || 0 }}</span>
              <span class="lv-bal-total">/ {{ bal.totalDays || bal.allocatedDays || 0 }}</span>
            </div>
            <div class="lv-bal-bar">
              <div class="lv-bal-fill" [style.width]="((bal.remainingDays || 0) / (bal.totalDays || 1) * 100) + '%'"></div>
            </div>
            <div class="lv-bal-lbl">days remaining</div>
          </div>
          <div class="lv-bal-card lv-bal-card--action" *ngIf="canEdit()" (click)="showAllocate=true">
            <svg viewBox="0 0 24 24" fill="none" width="22" height="22"><path d="M12 5v14M5 12h14" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/></svg>
            <div class="lv-bal-type">Allocate Days</div>
          </div>
        </div>

        <div class="lv-section" *ngIf="empPending.length > 0">
          <div class="lv-section-head">
            <span class="lv-section-title">Pending Approvals</span>
            <span class="lv-pend-chip">{{ empPending.length }}</span>
          </div>
          <div class="lv-pend-list">
            <div class="lv-pend-row" *ngFor="let lv of empPending">
              <div class="lv-pend-info">
                <span class="lv-type-dot" [style.background]="getBalanceColor(lv.leaveType)"></span>
                <div>
                  <div class="lv-pend-title">{{ lv.leaveType | titlecase }} Leave</div>
                  <div class="lv-pend-dates">{{ formatDate(lv.startDate) }} – {{ formatDate(lv.endDate) }}</div>
                  <div class="lv-pend-reason" *ngIf="lv.reason">{{ lv.reason }}</div>
                </div>
              </div>
              <div class="lv-pend-acts" *ngIf="canEdit()">
                <div *ngIf="rejectingId === lv.id" class="lv-reject-inline">
                  <input type="text" class="lv-reject-inp" [(ngModel)]="rejectReason" placeholder="Reason for rejection...">
                  <button class="lv-btn-confirm-reject" (click)="rejectLeave(lv)">Confirm</button>
                  <button class="lv-btn-cancel" (click)="rejectingId=null;rejectReason=''">Cancel</button>
                </div>
                <ng-container *ngIf="rejectingId !== lv.id">
                  <button class="lv-approve-btn" (click)="approveLeave(lv)" [disabled]="approvingId===lv.id">
                    <svg viewBox="0 0 14 14" fill="none" width="12" height="12"><path d="M2 7l4 4 6-7" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>
                    Approve
                  </button>
                  <button class="lv-reject-btn" (click)="rejectingId=lv.id">
                    <svg viewBox="0 0 14 14" fill="none" width="12" height="12"><path d="M3 3l8 8M11 3l-8 8" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/></svg>
                    Reject
                  </button>
                </ng-container>
              </div>
            </div>
          </div>
        </div>

        <div class="lv-section">
          <div class="lv-section-head">
            <span class="lv-section-title">Leave History</span>
          </div>
          <div class="lv-hist-table-wrap" *ngIf="empLeaves.length > 0">
            <table class="lv-hist-table">
              <thead>
                <tr>
                  <th>Type</th>
                  <th>From</th>
                  <th>To</th>
                  <th>Duration</th>
                  <th>Status</th>
                  <th>Reason</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let lv of empLeaves">
                  <td>
                    <span class="lv-type-pill" [style.background]="getBalanceColor(lv.leaveType)+'1a'" [style.color]="getBalanceColor(lv.leaveType)">
                      {{ lv.leaveType | titlecase }}
                    </span>
                  </td>
                  <td>{{ formatDate(lv.startDate) }}</td>
                  <td>{{ formatDate(lv.endDate) }}</td>
                  <td>{{ lv.duration || lv.days || '—' }}</td>
                  <td><span class="lv-status-badge" [ngClass]="getLeaveStatusClass(lv.status)">{{ lv.status | titlecase }}</span></td>
                  <td class="lv-reason-cell">{{ lv.reason || '—' }}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="tab-empty" *ngIf="empLeaves.length === 0">
            <svg viewBox="0 0 40 40" fill="none" width="36" height="36"><path d="M20 5c-7.5 7.5-12.5 12.5-12.5 17.5a12.5 12.5 0 0 0 25 0C32.5 17.5 27.5 12.5 20 5z" stroke="currentColor" stroke-width="1.5" stroke-linejoin="round"/></svg>
            <p>No leave history</p>
          </div>
        </div>
      </div>

      <div class="ph-tab-body" *ngIf="activeDetailTab==='assets'">
        <div class="ast-table-wrap" *ngIf="empAssets.length > 0">
          <table class="ast-table">
            <thead>
              <tr>
                <th>Asset</th>
                <th>Type</th>
                <th>Asset ID</th>
                <th>Assigned On</th>
                <th>Status</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let asset of empAssets">
                <td class="ast-name">{{ asset.name || asset.assetName || '—' }}</td>
                <td>{{ asset.type || asset.category || '—' }}</td>
                <td><span class="ast-id">{{ asset.assetId || asset.serialNumber || '—' }}</span></td>
                <td>{{ formatDate(asset.assignedDate || asset.assignedOn) }}</td>
                <td><span class="ast-status" [class.ast-ok]="asset.status==='active' || asset.status==='assigned'">{{ asset.status | titlecase }}</span></td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="tab-empty" *ngIf="empAssets.length === 0">
          <svg viewBox="0 0 40 40" fill="none" width="36" height="36"><rect x="4" y="10" width="32" height="24" rx="4" stroke="currentColor" stroke-width="1.5"/><path d="M12 10V7a8 8 0 0 1 16 0v3" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg>
          <p>No assets assigned</p>
        </div>
      </div>

    </div>
  </div>

  <div class="dir-page" *ngIf="pageTab==='attendance'">
  <div class="dir-toolbar">
    <div class="dir-title-group">
      <span class="dir-title">Attendance Directory</span>
      <span class="dir-date-badge">{{ formatDate(dirDate) }}</span>
    </div>
    <div class="dir-controls">
      <input type="date" class="dir-date-inp" [(ngModel)]="dirDate" (change)="loadDirAttendance()">
      <div class="dir-search-wrap">
        <svg viewBox="0 0 16 16" fill="none" width="13" height="13"><circle cx="7" cy="7" r="5" stroke="currentColor" stroke-width="1.5"/><path d="M11 11l3 3" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg>
        <input type="text" class="dir-search-inp" [(ngModel)]="dirSearch" placeholder="Search employee...">
      </div>
    </div>
  </div>

  <div class="dir-summary">
    <div class="dir-sum-card dir-sum-total">
      <span class="dir-sum-val">{{ employees.length }}</span>
      <span class="dir-sum-lbl">Total</span>
    </div>
    <div class="dir-sum-card dir-sum-present">
      <span class="dir-sum-val">{{ dirSummaryCount('present') }}</span>
      <span class="dir-sum-lbl">Present</span>
    </div>
    <div class="dir-sum-card dir-sum-absent">
      <span class="dir-sum-val">{{ dirSummaryCount('absent') }}</span>
      <span class="dir-sum-lbl">Absent</span>
    </div>
    <div class="dir-sum-card dir-sum-late">
      <span class="dir-sum-val">{{ dirSummaryCount('late') }}</span>
      <span class="dir-sum-lbl">Late</span>
    </div>
    <div class="dir-sum-card dir-sum-leave">
      <span class="dir-sum-val">{{ dirSummaryCount('on-leave') }}</span>
      <span class="dir-sum-lbl">On Leave</span>
    </div>
    <div class="dir-sum-card dir-sum-nm">
      <span class="dir-sum-val">{{ employees.length - dirRecords.length }}</span>
      <span class="dir-sum-lbl">Not Marked</span>
    </div>
  </div>

  <div class="dir-filter-row">
    <button class="dir-fpill" [class.active]="dirFilter==='all' && !dirShowRegularized"      (click)="dirFilter='all'; dirShowRegularized=false">All</button>
    <button class="dir-fpill" [class.active]="dirFilter==='present'"  (click)="dirFilter='present'; dirShowRegularized=false">Present</button>
    <button class="dir-fpill" [class.active]="dirFilter==='absent'"   (click)="dirFilter='absent'; dirShowRegularized=false">Absent</button>
    <button class="dir-fpill" [class.active]="dirFilter==='late'"     (click)="dirFilter='late'; dirShowRegularized=false">Late</button>
    <button class="dir-fpill" [class.active]="dirFilter==='on-leave'" (click)="dirFilter='on-leave'; dirShowRegularized=false">On Leave</button>
    <button class="dir-fpill dir-fpill--reg" [class.active]="dirShowRegularized" (click)="toggleDirRegularized()">
      <svg viewBox="0 0 14 14" fill="none" width="11" height="11"><path d="M2 7l3.5 3.5L12 3" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/><circle cx="11" cy="3" r="2.5" fill="currentColor" opacity="0.18"/></svg>
      Regularized
    </button>
  </div>

  <div class="dir-loading" *ngIf="dirLoading">
    <svg class="ph-spin" viewBox="0 0 24 24" fill="none" width="24" height="24">
      <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-dasharray="40 20"/>
    </svg>
    Loading attendance...
  </div>

  <div class="dir-table-wrap" *ngIf="!dirLoading">
    <table class="dir-table">
      <thead>
        <tr>
          <th>Employee</th>
          <th>Dept</th>
          <th>Status</th>
          <th>Check In</th>
          <th>Check Out</th>
          <th>Hours</th>
          <th>Notes</th>
          <th *ngIf="canEdit()"></th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let rec of filteredDirRecords" class="dir-row">
          <td>
            <div class="dir-emp-cell">
              <div class="dir-emp-av" [style.background]="getAvatarGradient(getEmpName(rec.employeeId))">
                {{ getInitials(getEmpById(rec.employeeId)) }}
              </div>
              <div>
                <div class="dir-emp-name">{{ getEmpName(rec.employeeId) }}</div>
                <div class="dir-emp-id">{{ getEmpById(rec.employeeId)?.employeeId || '—' }}</div>
              </div>
            </div>
          </td>
          <td class="dir-dept">{{ getDeptName(getEmpById(rec.employeeId)?.departmentId) }}</td>
          <td><span class="att-badge" [ngClass]="getAttStatusClass(rec.status)">{{ rec.status }}</span></td>
          <td class="dir-time">{{ formatTime(rec.checkIn) }}</td>
          <td class="dir-time">{{ formatTime(rec.checkOut) }}</td>
          <td class="dir-hrs">{{ rec.hoursWorked || '—' }}</td>
          <td class="dir-notes">{{ rec.notes || '—' }}</td>
          <td *ngIf="canEdit()">
            <button class="dir-edit-btn" (click)="markAttForDir(getEmpById(rec.employeeId))">Edit</button>
          </td>
        </tr>
        <ng-container *ngIf="dirFilter==='all'">
          <tr *ngFor="let emp of unmarkedEmployees" class="dir-row dir-row--nm">
            <td>
              <div class="dir-emp-cell">
                <div class="dir-emp-av" [style.background]="getAvatarGradient(emp.firstName+' '+emp.lastName)">{{ getInitials(emp) }}</div>
                <div>
                  <div class="dir-emp-name">{{ emp.firstName }} {{ emp.lastName }}</div>
                  <div class="dir-emp-id">{{ emp.employeeId || '—' }}</div>
                </div>
              </div>
            </td>
            <td class="dir-dept">{{ getDeptName(emp.departmentId) }}</td>
            <td><span class="dir-nm-badge">Not Marked</span></td>
            <td class="dir-time">—</td>
            <td class="dir-time">—</td>
            <td class="dir-hrs">—</td>
            <td class="dir-notes">—</td>
            <td *ngIf="canEdit()">
              <button class="dir-mark-btn" (click)="markAttForDir(emp)">Mark</button>
            </td>
          </tr>
        </ng-container>
      </tbody>
    </table>
    <div class="dir-empty" *ngIf="filteredDirRecords.length === 0 && dirFilter !== 'all'">
      No records match this filter
    </div>
  </div>
</div>

  <div class="lva-page" *ngIf="isLeavesTab()">

    <div class="lva-toolbar">
      <div class="lva-title-group">
        <span class="lva-title">Leaves</span>
        <span class="lva-pend-chip" *ngIf="pendingLeavesCount > 0">{{ pendingLeavesCount }} pending</span>
      </div>

      <div class="lva-sub-tabs">
        <button class="lva-sub-tab" [class.active]="isLeavesApprovalsTab()" (click)="switchLeaveSubTab('approvals')">
          <svg viewBox="0 0 16 16" fill="none" width="13" height="13"><path d="M2 8l4 4 8-8" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>
          Approvals
          <span class="lva-sub-badge" *ngIf="pendingLeavesCount > 0">{{ pendingLeavesCount }}</span>
        </button>
        <button class="lva-sub-tab" [class.active]="isLeavesBalancesTab()" (click)="switchLeaveSubTab('balances')">
          <svg viewBox="0 0 16 16" fill="none" width="13" height="13"><rect x="2" y="3" width="12" height="10" rx="1.5" stroke="currentColor" stroke-width="1.4"/><path d="M5 7h6M5 10h4" stroke="currentColor" stroke-width="1.4" stroke-linecap="round"/></svg>
          Leave Balances
        </button>
      </div>

      <div class="lva-controls">
        <div class="lva-search-wrap" *ngIf="isLeavesApprovalsTab()">
          <svg viewBox="0 0 16 16" fill="none" width="13" height="13"><circle cx="7" cy="7" r="5" stroke="currentColor" stroke-width="1.5"/><path d="M11 11l3 3" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg>
          <input type="text" class="lva-search-inp" [(ngModel)]="leaveSearch" (ngModelChange)="resetLeavePagination()" placeholder="Search employee or type...">
        </div>
        <div class="lva-search-wrap" *ngIf="isLeavesBalancesTab()">
          <svg viewBox="0 0 16 16" fill="none" width="13" height="13"><circle cx="7" cy="7" r="5" stroke="currentColor" stroke-width="1.5"/><path d="M11 11l3 3" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg>
          <input type="text" class="lva-search-inp" [(ngModel)]="balanceSearch" placeholder="Search employee...">
        </div>
        <button class="lva-allocate-btn" *ngIf="canEdit()" (click)="openBulkAllocate()">
          <svg viewBox="0 0 16 16" fill="none" width="13" height="13"><circle cx="8" cy="8" r="6.5" stroke="currentColor" stroke-width="1.4"/><path d="M8 5v6M5 8h6" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg>
          Allocate Leave
        </button>
        <button class="lva-refresh-btn" (click)="refreshLeaveTab()">
          <svg viewBox="0 0 16 16" fill="none" width="13" height="13"><path d="M14 8A6 6 0 1 1 8 2" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/><path d="M14 2v6h-6" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>
        </button>
      </div>
    </div>

    <ng-container *ngIf="isLeavesApprovalsTab()">
      <div class="lva-filter-row">
        <button class="lva-fpill" [class.active]="leaveStatusFilter==='pending'"  (click)="setLeaveStatusFilter('pending')">
          Pending <span *ngIf="pendingLeavesCount > 0" class="lva-pill-badge">{{ pendingLeavesCount }}</span>
        </button>
        <button class="lva-fpill" [class.active]="leaveStatusFilter==='approved'" (click)="setLeaveStatusFilter('approved')">Approved</button>
        <button class="lva-fpill" [class.active]="leaveStatusFilter==='rejected'" (click)="setLeaveStatusFilter('rejected')">Rejected</button>
        <button class="lva-fpill" [class.active]="leaveStatusFilter==='all'"      (click)="setLeaveStatusFilter('all')">All</button>
      </div>

      <div class="dir-loading" *ngIf="allLeavesLoading">
        <svg class="ph-spin" viewBox="0 0 24 24" fill="none" width="24" height="24"><circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-dasharray="40 20"/></svg>
        Loading leave requests...
      </div>

      <div class="lva-list" *ngIf="!allLeavesLoading">
        <div class="lva-card" *ngFor="let lv of paginatedAllLeaves">
          <div class="lva-card-left">
            <div class="lva-emp-av" [style.background]="getAvatarGradient(getEmpName(lv.employeeId))">
              {{ getInitials(getEmpById(lv.employeeId)) }}
            </div>
            <div class="lva-emp-info">
              <div class="lva-emp-name">{{ getEmpName(lv.employeeId) }}</div>
              <div class="lva-emp-dept">{{ getDeptName(getEmpById(lv.employeeId)?.departmentId) }}</div>
            </div>
          </div>
          <div class="lva-card-mid">
            <span class="lva-type-tag" [style.background]="getBalanceColor(lv.leaveType)+'18'" [style.color]="getBalanceColor(lv.leaveType)">{{ lv.leaveType | titlecase }}</span>
            <div class="lva-dates">
              <svg viewBox="0 0 14 14" fill="none" width="11" height="11"><rect x="1" y="2" width="12" height="10" rx="1.5" stroke="currentColor" stroke-width="1.2"/><path d="M4 1v2M10 1v2M1 5h12" stroke="currentColor" stroke-width="1.2" stroke-linecap="round"/></svg>
              {{ formatDate(lv.startDate) }}<span *ngIf="lv.endDate !== lv.startDate"> – {{ formatDate(lv.endDate) }}</span>
            </div>
            <div class="lva-reason" *ngIf="lv.reason">{{ lv.reason }}</div>
          </div>
          <div class="lva-card-right">
            <span class="lv-status-badge" [ngClass]="getLeaveStatusClass(lv.status)">{{ lv.status | titlecase }}</span>
            <ng-container *ngIf="lv.status === 'pending' && canEdit()">
              <div *ngIf="leaveRejectingId === lv.id" class="lva-reject-inline">
                <input type="text" class="lv-reject-inp" [(ngModel)]="leaveRejectReason" placeholder="Reason...">
                <button class="lv-btn-confirm-reject" (click)="rejectLeave(lv, 'dir')">Confirm</button>
                <button class="lv-btn-cancel" (click)="leaveRejectingId=null; leaveRejectReason=''">Cancel</button>
              </div>
              <div class="lva-action-btns" *ngIf="leaveRejectingId !== lv.id">
                <button class="lv-approve-btn" (click)="approveLeave(lv, 'dir')" [disabled]="approvingId===lv.id">
                  <svg viewBox="0 0 14 14" fill="none" width="12" height="12"><path d="M2 7l4 4 6-7" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>Approve
                </button>
                <button class="lv-reject-btn" (click)="leaveRejectingId=lv.id">
                  <svg viewBox="0 0 14 14" fill="none" width="12" height="12"><path d="M3 3l8 8M11 3l-8 8" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/></svg>Reject
                </button>
              </div>
            </ng-container>
          </div>
        </div>
        <div class="tab-empty" *ngIf="filteredAllLeaves.length === 0">
          <svg viewBox="0 0 40 40" fill="none" width="36" height="36"><path d="M20 5c-7.5 7.5-12.5 12.5-12.5 17.5a12.5 12.5 0 0 0 25 0C32.5 17.5 27.5 12.5 20 5z" stroke="currentColor" stroke-width="1.5" stroke-linejoin="round"/></svg>
          <p>No {{ leaveStatusFilter === 'all' ? '' : leaveStatusFilter }} leave requests</p>
        </div>
      </div>

      <div class="lva-pagination" *ngIf="!allLeavesLoading && filteredAllLeaves.length > 0">
        <div class="lva-page-meta">
          Showing {{ leavePageStart }}-{{ leavePageEnd }} of {{ filteredAllLeaves.length }}
        </div>

        <div class="lva-page-size">
          <span>Rows</span>
          <select class="lva-page-size-select" [ngModel]="leavePageSize" (ngModelChange)="setLeavePageSize($event)">
            <option *ngFor="let size of leavePageSizeOptions" [ngValue]="size">{{ size }}</option>
          </select>
        </div>

        <div class="lva-page-controls">
          <button class="lva-page-btn" (click)="goToLeavePage(clampedLeavePage - 1)" [disabled]="clampedLeavePage <= 1">
            <svg viewBox="0 0 14 14" fill="none" width="12" height="12"><path d="M9 3L5 7l4 4" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>
          </button>
          <button class="lva-page-num" *ngFor="let page of leavePageNumbers" [class.active]="page === clampedLeavePage" (click)="goToLeavePage(page)">
            {{ page }}
          </button>
          <button class="lva-page-btn" (click)="goToLeavePage(clampedLeavePage + 1)" [disabled]="clampedLeavePage >= leaveTotalPages">
            <svg viewBox="0 0 14 14" fill="none" width="12" height="12"><path d="M5 3l4 4-4 4" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>
          </button>
        </div>
      </div>
    </ng-container>

    <ng-container *ngIf="isLeavesBalancesTab()">
      <div class="dir-loading" *ngIf="balancesLoading">
        <svg class="ph-spin" viewBox="0 0 24 24" fill="none" width="24" height="24"><circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-dasharray="40 20"/></svg>
        Loading balances...
      </div>

      <div class="lvbal-table-wrap" *ngIf="!balancesLoading">
        <table class="lvbal-table">
          <thead>
            <tr>
              <th>Employee</th>
              <th>Department</th>
              <th>Casual</th>
              <th>Sick</th>
              <th>Earned</th>
              <th>Optional</th>
              <th *ngIf="canEdit()"></th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let emp of filteredBalanceEmployees" class="dir-row">
              <td>
                <div class="dir-emp-cell">
                  <div class="dir-emp-av" [style.background]="getAvatarGradient(emp.firstName+' '+emp.lastName)">{{ getInitials(emp) }}</div>
                  <div>
                    <div class="dir-emp-name">{{ emp.firstName }} {{ emp.lastName }}</div>
                    <div class="dir-emp-id">{{ emp.employeeId || '—' }}</div>
                  </div>
                </div>
              </td>
              <td class="dir-dept">{{ getDeptName(emp.departmentId) }}</td>
              <td class="lvbal-cell">
                <span class="lvbal-num lvbal-casual">{{ getBalRemaining(emp.id, 'casual') }}</span>
                <span class="lvbal-total">/ {{ getBalTotal(emp.id, 'casual') }}</span>
              </td>
              <td class="lvbal-cell">
                <span class="lvbal-num lvbal-sick">{{ getBalRemaining(emp.id, 'sick') }}</span>
                <span class="lvbal-total">/ {{ getBalTotal(emp.id, 'sick') }}</span>
              </td>
              <td class="lvbal-cell">
                <span class="lvbal-num lvbal-earned">{{ getBalRemaining(emp.id, 'earned') }}</span>
                <span class="lvbal-total">/ {{ getBalTotal(emp.id, 'earned') }}</span>
              </td>
              <td class="lvbal-cell">
                <span class="lvbal-num lvbal-optional">{{ getBalRemaining(emp.id, 'optional') }}</span>
                <span class="lvbal-total">/ {{ getBalTotal(emp.id, 'optional') }}</span>
              </td>
              <td *ngIf="canEdit()">
                <button class="dir-mark-btn" (click)="openBulkAllocate(emp)">+ Allocate</button>
              </td>
            </tr>
          </tbody>
        </table>
        <div class="dir-empty" *ngIf="filteredBalanceEmployees.length === 0">No employees found</div>
      </div>
    </ng-container>

  </div>
</div>

<div class="sd-overlay" *ngIf="showBulkAllocate" (click)="showBulkAllocate=false"></div>
<div class="sd-drawer sd-drawer--wide" [class.sd-drawer--open]="showBulkAllocate">
  <div class="sd-head">
    <div>
      <span class="sd-title">Bulk Allocate Leave</span>
      <div class="sd-subtitle">Allocate multiple leave types to a group of employees</div>
    </div>
    <button class="sd-close" (click)="showBulkAllocate=false">
      <svg viewBox="0 0 14 14" fill="none" width="12" height="12"><path d="M2 2l10 10M12 2L2 12" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/></svg>
    </button>
  </div>

  <div class="sd-body">

    <div class="ba-section">
      <div class="ba-section-head">
        <span class="ba-section-num">1</span>
        <span class="ba-section-title">Who receives the leave?</span>
      </div>

      <div class="ba-target-tabs">
        <button class="ba-target-tab" [class.active]="bulkTarget==='employees'" (click)="bulkTarget='employees'">
          <svg viewBox="0 0 16 16" fill="none" width="13" height="13"><circle cx="8" cy="5" r="3" stroke="currentColor" stroke-width="1.4"/><path d="M2 14c0-3.314 2.686-6 6-6s6 2.686 6 6" stroke="currentColor" stroke-width="1.4" stroke-linecap="round"/></svg>
          Select Employees
        </button>
        <button class="ba-target-tab" [class.active]="bulkTarget==='team'" (click)="bulkTarget='team'">
          <svg viewBox="0 0 16 16" fill="none" width="13" height="13"><circle cx="5" cy="6" r="2.5" stroke="currentColor" stroke-width="1.3"/><circle cx="11" cy="6" r="2.5" stroke="currentColor" stroke-width="1.3"/><path d="M1 14c0-2.21 1.79-4 4-4M10 10c2.21 0 4 1.79 4 4" stroke="currentColor" stroke-width="1.3" stroke-linecap="round"/></svg>
          By Team
        </button>
        <button class="ba-target-tab" [class.active]="bulkTarget==='designation'" (click)="bulkTarget='designation'">
          <svg viewBox="0 0 16 16" fill="none" width="13" height="13"><rect x="2" y="3" width="12" height="9" rx="1.5" stroke="currentColor" stroke-width="1.3"/><path d="M5 7h6M5 10h4" stroke="currentColor" stroke-width="1.3" stroke-linecap="round"/></svg>
          By Designation
        </button>
      </div>

      <div class="ba-emp-picker" *ngIf="bulkTarget==='employees'">
        <div class="ba-emp-search-wrap">
          <svg viewBox="0 0 16 16" fill="none" width="13" height="13"><circle cx="7" cy="7" r="5" stroke="currentColor" stroke-width="1.5"/><path d="M11 11l3 3" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg>
          <input class="ba-emp-search-inp" [(ngModel)]="bulkEmpSearch" placeholder="Search employees...">
          <button class="ba-sel-all-btn" (click)="selectAllBulkEmps()">
            {{ bulkSelectedEmps.size === employees.length ? 'Deselect all' : 'Select all' }}
          </button>
        </div>
        <div class="ba-emp-list">
          <label class="ba-emp-row" *ngFor="let emp of bulkFilteredEmps">
            <input type="checkbox" [checked]="bulkSelectedEmps.has(emp.id)" (change)="toggleBulkEmp(emp.id)" class="ba-checkbox">
            <div class="ba-emp-av" [style.background]="getAvatarGradient(emp.firstName+' '+emp.lastName)">{{ getInitials(emp) }}</div>
            <div class="ba-emp-info">
              <div class="ba-emp-name">{{ emp.firstName }} {{ emp.lastName }}</div>
              <div class="ba-emp-sub">{{ getDeptName(emp.departmentId) }} · {{ emp.designation || emp.role }}</div>
            </div>
          </label>
        </div>
      </div>

      <div class="ba-single-pick" *ngIf="bulkTarget==='team'">
        <label class="sd-label">Select Team</label>
        <select class="sd-input" [(ngModel)]="bulkTeamId">
          <option value="">Choose a team</option>
          <option *ngFor="let t of teams" [value]="t.id">{{ t.name }}</option>
        </select>
      </div>

      <div class="ba-single-pick" *ngIf="bulkTarget==='designation'">
        <label class="sd-label">Select Designation / Role</label>
        <select class="sd-input" [(ngModel)]="bulkDesignation">
          <option value="">Choose designation</option>
          <option *ngFor="let d of uniqueDesignations" [value]="d">{{ d | titlecase }}</option>
        </select>
      </div>
    </div>

    <div class="ba-section">
      <div class="ba-section-head">
        <span class="ba-section-num">2</span>
        <span class="ba-section-title">Which leave types &amp; how many days?</span>
      </div>
      <div class="ba-leave-grid">
        <div class="ba-leave-row" *ngFor="let alloc of bulkAllocations" [class.ba-leave-row--off]="!alloc.enabled">
          <label class="ba-leave-toggle">
            <input type="checkbox" [(ngModel)]="alloc.enabled" class="ba-checkbox">
            <span class="ba-leave-dot" [style.background]="alloc.color"></span>
            <span class="ba-leave-label">{{ alloc.label }}</span>
          </label>
          <div class="ba-days-wrap" [class.ba-days-wrap--disabled]="!alloc.enabled">
            <input type="number" class="ba-days-inp" [(ngModel)]="alloc.days" min="0" step="1" placeholder="0" [disabled]="!alloc.enabled">
            <span class="ba-days-unit">days</span>
          </div>
        </div>
      </div>
    </div>

    <div class="ba-section ba-section--inline">
      <div class="ba-section-head">
        <span class="ba-section-num">3</span>
        <span class="ba-section-title">Financial year</span>
      </div>
      <input type="number" class="sd-input ba-year-inp" [(ngModel)]="bulkYear" min="2020" max="2099" step="1">
    </div>

  </div>

  <div class="sd-footer">
    <div class="ba-preview" *ngIf="bulkPreviewCount > 0">
      <svg viewBox="0 0 14 14" fill="none" width="12" height="12"><circle cx="7" cy="7" r="5.5" stroke="currentColor" stroke-width="1.3"/><path d="M7 4.5v3l1.5 1.5" stroke="currentColor" stroke-width="1.3" stroke-linecap="round"/></svg>
      <strong>{{ bulkPreviewCount }}</strong> employee{{ bulkPreviewCount === 1 ? '' : 's' }} will be updated
    </div>
    <button class="sd-cancel-btn" (click)="showBulkAllocate=false">Cancel</button>
    <button class="sd-submit-btn" (click)="submitBulkAllocate()" [disabled]="bulkSubmitting || bulkPreviewCount === 0">
      {{ bulkSubmitting ? 'Allocating…' : 'Allocate Leave' }}
    </button>
  </div>
</div>

<div class="ph-page-loading" *ngIf="loading">
  <svg class="ph-spin" viewBox="0 0 24 24" fill="none" width="32" height="32">
    <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-dasharray="40 20"/>
  </svg>
</div>

<div class="sd-overlay" *ngIf="showMarkAtt" (click)="showMarkAtt=false"></div>
<div class="sd-drawer" [class.sd-drawer--open]="showMarkAtt">
  <div class="sd-head">
    <span class="sd-title">Mark Attendance</span>
    <button class="sd-close" (click)="showMarkAtt=false">
      <svg viewBox="0 0 16 16" fill="none" width="14" height="14"><path d="M3 3l10 10M13 3L3 13" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/></svg>
    </button>
  </div>
  <div class="sd-body">
    <div class="sd-emp-banner">
      <div class="sd-emp-av" [style.background]="getAvatarGradient(selectedEmp?.firstName + ' ' + selectedEmp?.lastName)">{{ getInitials(selectedEmp) }}</div>
      <div>
        <div class="sd-emp-name">{{ selectedEmp?.firstName }} {{ selectedEmp?.lastName }}</div>
        <div class="sd-emp-sub">{{ getDeptName(selectedEmp?.departmentId) }}</div>
      </div>
    </div>
    <div class="sd-field">
      <label class="sd-label">Date</label>
      <input type="date" class="sd-input" [(ngModel)]="markAttForm.date">
    </div>
    <div class="sd-row-2">
      <div class="sd-field">
        <label class="sd-label">Check In</label>
        <input type="time" class="sd-input" [(ngModel)]="markAttForm.checkIn">
      </div>
      <div class="sd-field">
        <label class="sd-label">Check Out</label>
        <input type="time" class="sd-input" [(ngModel)]="markAttForm.checkOut">
      </div>
    </div>
    <div class="sd-field">
      <label class="sd-label">Status</label>
      <select class="sd-input" [(ngModel)]="markAttForm.status">
        <option *ngFor="let opt of attStatusOptions" [value]="opt.value">{{ opt.label }}</option>
      </select>
    </div>
    <div class="sd-field">
      <label class="sd-label">Notes</label>
      <textarea class="sd-input sd-textarea" [(ngModel)]="markAttForm.notes" rows="2" placeholder="Optional notes..."></textarea>
    </div>
  </div>
  <div class="sd-footer">
    <button class="sd-cancel-btn" (click)="showMarkAtt=false">Cancel</button>
    <button type="button" class="sd-submit-btn" (click)="submitMarkAtt()" [disabled]="markAttSubmitting">
      {{ markAttSubmitting ? 'Saving...' : 'Mark Attendance' }}
    </button>
  </div>
</div>

<div class="sd-overlay" *ngIf="showEditEmp" (click)="showEditEmp=false"></div>
<div class="sd-drawer" [class.sd-drawer--open]="showEditEmp">
  <div class="sd-head">
    <span class="sd-title">Edit Profile</span>
    <button class="sd-close" (click)="showEditEmp=false">
      <svg viewBox="0 0 16 16" fill="none" width="14" height="14"><path d="M3 3l10 10M13 3L3 13" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/></svg>
    </button>
  </div>
  <div class="sd-body">
    <div class="sd-row-2">
      <div class="sd-field"><label class="sd-label">First Name</label><input type="text" class="sd-input" [(ngModel)]="editForm.firstName"></div>
      <div class="sd-field"><label class="sd-label">Last Name</label><input type="text" class="sd-input" [(ngModel)]="editForm.lastName"></div>
    </div>
    <div class="sd-field"><label class="sd-label">Email</label><input type="email" class="sd-input" [(ngModel)]="editForm.email"></div>
    <div class="sd-field"><label class="sd-label">Phone</label><input type="text" class="sd-input" [(ngModel)]="editForm.phone"></div>
    <div class="sd-field"><label class="sd-label">Employee ID</label><input type="text" class="sd-input" [(ngModel)]="editForm.employeeId"></div>
    <div class="sd-field"><label class="sd-label">Position / Title</label><input type="text" class="sd-input" [(ngModel)]="editForm.position"></div>
    <div class="sd-field">
      <label class="sd-label">Department</label>
      <select class="sd-input" [(ngModel)]="editForm.departmentId">
        <option value="">Select department</option>
        <option *ngFor="let d of departments" [value]="d.id">{{ d.name }}</option>
      </select>
    </div>
    <div class="sd-row-2">
      <div class="sd-field">
        <label class="sd-label">Role</label>
        <select class="sd-input" [(ngModel)]="editForm.role">
          <option *ngFor="let r of roleOptions" [value]="r">{{ r | titlecase }}</option>
        </select>
      </div>
      <div class="sd-field">
        <label class="sd-label">Location</label>
        <select class="sd-input" [(ngModel)]="editForm.location">
          <option *ngFor="let l of locationOptions" [value]="l">{{ l }}</option>
        </select>
      </div>
    </div>
    <div class="sd-field">
      <label class="sd-label">Status</label>
      <select class="sd-input" [(ngModel)]="editForm.status">
        <option *ngFor="let s of statusOptions" [value]="s">{{ s === 'on_leave' ? 'On Leave' : (s | titlecase) }}</option>
      </select>
    </div>
  </div>
  <div class="sd-footer">
    <button class="sd-cancel-btn" (click)="showEditEmp=false">Cancel</button>
    <button class="sd-submit-btn" (click)="submitEditEmp()" [disabled]="editSubmitting">
      {{ editSubmitting ? 'Saving...' : 'Save Changes' }}
    </button>
  </div>
</div>

<div class="sd-overlay" *ngIf="showAddEmp" (click)="showAddEmp=false"></div>
<div class="sd-drawer" [class.sd-drawer--open]="showAddEmp">
  <div class="sd-head">
    <span class="sd-title">Add Employee</span>
    <button class="sd-close" (click)="showAddEmp=false">
      <svg viewBox="0 0 16 16" fill="none" width="14" height="14"><path d="M3 3l10 10M13 3L3 13" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/></svg>
    </button>
  </div>
  <div class="sd-body">
    <div class="sd-row-2">
      <div class="sd-field"><label class="sd-label">First Name</label><input type="text" class="sd-input" [(ngModel)]="addForm.firstName" placeholder="John"></div>
      <div class="sd-field"><label class="sd-label">Last Name</label><input type="text" class="sd-input" [(ngModel)]="addForm.lastName" placeholder="Doe"></div>
    </div>
    <div class="sd-field"><label class="sd-label">Email</label><input type="email" class="sd-input" [(ngModel)]="addForm.email" placeholder="john.doe@company.com"></div>
    <div class="sd-field"><label class="sd-label">Phone</label><input type="text" class="sd-input" [(ngModel)]="addForm.phone" placeholder="+91 9999999999"></div>
    <div class="sd-field"><label class="sd-label">Employee ID</label><input type="text" class="sd-input" [(ngModel)]="addForm.employeeId" placeholder="EMP-001"></div>
    <div class="sd-field"><label class="sd-label">Position / Title</label><input type="text" class="sd-input" [(ngModel)]="addForm.position" placeholder="Software Engineer"></div>
    <div class="sd-field">
      <label class="sd-label">Department</label>
      <select class="sd-input" [(ngModel)]="addForm.departmentId">
        <option value="">Select department</option>
        <option *ngFor="let d of departments" [value]="d.id">{{ d.name }}</option>
      </select>
    </div>
    <div class="sd-row-2">
      <div class="sd-field">
        <label class="sd-label">Role</label>
        <select class="sd-input" [(ngModel)]="addForm.role">
          <option *ngFor="let r of roleOptions" [value]="r">{{ r | titlecase }}</option>
        </select>
      </div>
      <div class="sd-field">
        <label class="sd-label">Location</label>
        <select class="sd-input" [(ngModel)]="addForm.location">
          <option *ngFor="let l of locationOptions" [value]="l">{{ l }}</option>
        </select>
      </div>
    </div>
  </div>
  <div class="sd-footer">
    <button class="sd-cancel-btn" (click)="showAddEmp=false">Cancel</button>
    <button class="sd-submit-btn" (click)="submitAddEmp()" [disabled]="addSubmitting">
      {{ addSubmitting ? 'Adding...' : 'Add Employee' }}
    </button>
  </div>
</div>

<div class="sd-overlay" *ngIf="showAllocate" (click)="showAllocate=false"></div>
<div class="sd-drawer sd-drawer--sm" [class.sd-drawer--open]="showAllocate">
  <div class="sd-head">
    <span class="sd-title">Allocate Leave Days</span>
    <button class="sd-close" (click)="showAllocate=false">
      <svg viewBox="0 0 16 16" fill="none" width="14" height="14"><path d="M3 3l10 10M13 3L3 13" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/></svg>
    </button>
  </div>
  <div class="sd-body">
    <div class="sd-emp-banner">
      <div class="sd-emp-av" [style.background]="getAvatarGradient(selectedEmp?.firstName + ' ' + selectedEmp?.lastName)">{{ getInitials(selectedEmp) }}</div>
      <div>
        <div class="sd-emp-name">{{ selectedEmp?.firstName }} {{ selectedEmp?.lastName }}</div>
        <div class="sd-emp-sub">Leave allocation</div>
      </div>
    </div>
    <div class="sd-field">
      <label class="sd-label">Leave Type</label>
      <select class="sd-input" [(ngModel)]="allocateForm.leaveType">
        <option *ngFor="let opt of leaveTypeOptions" [value]="opt.value">{{ opt.label }}</option>
      </select>
    </div>
    <div class="sd-field">
      <label class="sd-label">Number of Days</label>
      <input type="number" class="sd-input" [(ngModel)]="allocateForm.days" min="0" max="365">
    </div>
  </div>
  <div class="sd-footer">
    <button class="sd-cancel-btn" (click)="showAllocate=false">Cancel</button>
    <button class="sd-submit-btn" (click)="submitAllocate()" [disabled]="allocating">
      {{ allocating ? 'Allocating...' : 'Allocate Days' }}
    </button>
  </div>
</div>

